module.exports = __webpack_public_path__ + "static/media/thumbnail.f668ee09.jpg";